/**
 * @author Mikko Koponen <koponen@iki.fi>
 * @url http://stackoverflow.com/questions/2200494/jquery-trigger-event-when-an-element-is-removed-from-the-dom
 * @url http://aijai.net/~mtkopone/
 * @example
 *
 *	$('.thing').bind('destroyed', function() {
 *	  // do stuff
 *	})
 */

	(function($){
	  $.event.special.destroyed = {
	    remove: function(o) {
	      if (o.handler) {
	        o.handler()
	      }
	    }
	  }
	})(jQuery);